export default "__VITE_ASSET__B9SEh5LN__"